/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Segment
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import UpdateAxios from "../../axiosComponent/update";
import CreateAxios from "../../axiosComponent/create";
import { DateData } from "../../dynamicComponent/datepick";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { translate } from "react-i18next";
import MyCity from '../../dynamicComponent/myCity';
import { MyNormalInput } from '../../dynamicComponent/myInputs';
import { COOKIE_USER_TOKEN, LOCAL_STORAGE, DATE_FORMATS } from "../../../utils/constant";
import Axios from "axios";
import moment from 'moment';
import cogoToast from "cogo-toast";

const ModalUpdate = ({ values, isSubmitting, handleSubmit, setFieldValue, t, bid, bid_amount, vehicle_id, userKey, ...props }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [lat, setlat] = useState(0);
  const [orderType, setOrderType] = useState('');
  const [locationErr, setLocationErr] = useState(false);
  const [LastUpdatedErr, setLastUpdatedErr] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [defaultDelivery, setdefaultDelivery] = useState({});

  const [long, setlong] = useState(0);
  let handleOpen = async (userKey) => {
    const data = {
      "order_id": props.vendor_order_id,
      "customer_no": LOCAL_STORAGE.customerNo,
      "user_id": LOCAL_STORAGE.userId
    }
    Axios.post(`${process.env.REACT_APP_TA_API_URL}/orders/update_location_manually/config`, data, { headers: { 'Content-Type': 'application/json', 'Authorization': `${COOKIE_USER_TOKEN}` } }).then((response) => {
      setFieldValue('orderType', response?.data?.resultSet?.service_type)
      if (response?.data?.resultSet?.service_type == 'FTL') {
        if (userKey) {
          setmodalOpen(true);
        } else {
          cogoToast.error("Please contact support team to link your tracking account to update location details")
        }
        setOrderType('FTL')
      } else {
        setOrderType('PTL')
        setmodalOpen(true);
      }
    })
  }
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setSubmitting(true);
    getVehicleNo();
    setLocationErr(true)
    setLastUpdatedErr(true)
  };

  let fetchCityInfo = (data) => {
    setlat(data.lattitude)
    setlong(data.longitude)
  }

  const getVehicleNo = async () => {
    let vehicleNum = await CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleMaster/${vehicle_id}` })
      .then((res) => {
        return res.data.resultSet[0]['vehicleNumber']
      })
      .catch((err) => console.log(err));
    values.vehicleNo = vehicleNum
    values.lat = lat
    values.long = long
    handleSubmit();
  };

  useEffect(() => {
    if (props?.deliveryDetails && props?.deliveryDetails.length > 0) {
      setdefaultDelivery(props?.deliveryDetails[0])
    }
  }, [props.deliveryDetails])

  const checkRequired = () => {
    if (!values.location) {
      setLocationErr(true)
    }
    if (!values.lastUpdated) {
      setLastUpdatedErr(true)
    }
    let { delivery_reference_no, transporter_lr_no, delivery_id } = props.deliveryDetails[0]
    if (!delivery_reference_no || !transporter_lr_no || !delivery_id) {
      props.successAlertDispatcher({
        type: "error",
        messageHeader: "Error",
        messageBody:
          !delivery_reference_no ?
            `Delivery Reference No is Required`
            : !transporter_lr_no ?
              `Transporter lr No is Required`
              : !delivery_id ?
                `Delivery is Required`
                : null
      });
    }
  }

  return (
    <div>
      <Modal
        style={{ overflow: "inherit" }}
        open={modalOpen}
        onClose={handleClose}
        size="mini"
        trigger={
          <Button
            type="button"
            onClick={() => handleOpen(userKey)}
            size="mini"
            basic color="blue"
            className="p-bold-600"
            disabled={props.disableUpdateDetails}
          >
            {t("update_details") || "Update Details"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{t("update_details") || "Update Details"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {
              orderType && orderType === 'FTL' ?
                <div className="ui form">
                  <FormUi.Field width={3}>
                    <label className="labelName">
                      {t("city") || "City"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                  >
                    <Fieldmik component={MyCity} getCityInfo={fetchCityInfo} name="city" />
                  </FormUi.Field>
                  <FormUi.Field>
                    <label className="labelName">{t("date") || "Date"}</label>
                  </FormUi.Field>
                  <FormUi.Field width={12}>
                    <DateData
                      name="lastUpdated"
                      autoComplete="off"
                      showTimeSelect
                      timeFormat="HH:mm"
                      popperClassName="dateTime"
                      dateFormat="dd/MM/yyyy HH:mm"
                      timeIntervals={5}
                      customInput={
                        <FormUi.Input
                          icon="time"
                          className="dateWidth"
                          iconPosition="left"
                        />
                      }
                    />
                  </FormUi.Field>
                  <FormUi.Field >
                    <label>{t("temperature") || "Temperature"}</label>
                  </FormUi.Field>
                  <FormUi.Field width={12}>
                    <Fieldmik component={MyNormalInput} name="temperature1" />
                  </FormUi.Field>

                </div>
                :
                <div className="ui form">
                  <FormUi.Field width={3}>
                    <label className="labelName">
                      Location
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={12}
                  >
                    <Fieldmik placeholder="Location" component={MyNormalInput} name="location" />
                    {
                      locationErr && !values.location ? <p style={{ color: 'red', fontSize: '12px' }}>Location is Required</p> : null
                    }
                  </FormUi.Field>
                  <FormUi.Field>
                    <label className="labelName">{t("date") || "Date"}</label>
                  </FormUi.Field>
                  <FormUi.Field width={12}>
                    <DateData
                      name="lastUpdated"
                      autoComplete="off"
                      showTimeSelect
                      maxDate={new Date()}
                      timeFormat="HH:mm"
                      popperClassName="dateTime"
                      dateFormat="dd/MM/yyyy HH:mm"
                      timeIntervals={5}
                      customInput={
                        <FormUi.Input
                          icon="time"
                          className="dateWidth"
                          iconPosition="left"
                        />
                      }
                    />
                    {
                      LastUpdatedErr && !values.lastUpdated ? <p style={{ color: 'red', fontSize: '12px' }}>Last Update Date is Required</p> : null
                    }
                  </FormUi.Field>
                </div>
            }
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {
            orderType && orderType === 'FTL' ?
              <Button
                type="submit"
                onClick={handleSubmited}
                // disabled={submitForm == true ? false : true}
                size="mini"
                className="w3-blue w3-round w3-hover-blue"
              >
                {t("action_button.submit") || "Submit"}
              </Button>
              :
              <Button
                type="submit"
                onClick={() => {
                  values.location && values.lastUpdated && defaultDelivery.delivery_reference_no && defaultDelivery.transporter_lr_no && defaultDelivery.delivery_id ?
                    handleSubmited()
                    : checkRequired()
                }}
                disabled={submitting}
                size="mini"
                className="w3-blue w3-round w3-hover-blue"
              >
                {t("action_button.submit") || "Submit"}
              </Button>
          }
        </Modal.Actions>
      </Modal>
    </div >
  );
};

const FormikUpdate = withFormik({
  mapPropsToValues() {
    return {
      lastUpdated: new Date(),
      city: "",
      temperature1: "",
      action: "pushVendorVehicleData",
      vehicleNo: "",
      lat: "",
      long: "",
      orderType: "",
      location: ""
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    const { delivery_reference_no, transporter_lr_no, delivery_id } = props.deliveryDetails[0]
    if (values?.orderType == 'PTL') {
      let payload = {
        location_string: values.location,
        last_updated_at: values.lastUpdated,
        delivery_reference_no,
        transporter_lr_no,
        delivery_id,
        customer_no: LOCAL_STORAGE.customerNo,
        user_id: LOCAL_STORAGE.userId
      }
      CreateAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/PTL/update_location_manually`, payload
      }).then((res) => {
        setSubmitting(false);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.Message,
        }).then(() => window.location.reload());
      }).catch((err) => {
        console.log("ERROR : ", err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        }).then(() => window.location.reload());
      });

    } else {
      let payload = {
        action: 'pushVendorVehicleData',
        jsonreq: {
          userkey: props.userKey,
          vehicleNo: values.vehicleNo,
          latitude: values.lat,
          longitude: values.long,
          lastUpdated: moment.parseZone(values.lastUpdated).format(DATE_FORMATS.YYYYMMDDHHmmss),
          temperature1: values.temperature1
        }
      }

      CreateAxios({
        completeURL: `${process.env.REACT_APP_BASE_URL}/speed/gps`, payload
      }).then((res) => {
        setSubmitting(false);
        if (res.data.Message) {
          props.successAlertDispatcher({
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.Message,
          });
        }
        else {
          props.successAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: res.data.Error,
          });
        }
      }).catch((err) => {
        console.log("ERROR : ", err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
    }
  },
})(ModalUpdate);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikUpdate)
);
